import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./HomePage";
import FormComponent from "./FormComponent";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/form/:goldenTicketId" element={<FormComponent />} />
      </Routes>
    </Router>
  );
}

export default App;
